import React, { useContext, useState } from 'react';
import classNames from './addFeesForm.module.scss';
import Select from 'antd/lib/select';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { useQuery } from 'react-query';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { FirebaseContext } from '../../../context/FirebaseContext';
import { useAccountsHeads } from '../../../NecttosComp/APICaller/queryHooks';

import { getFeeStructure, getUserListNew } from '../../../NecttosComp/APICaller/ApiServices';
import moment from 'moment';
import Scrollbars from 'react-custom-scrollbars';
import { v4 as uuidv4 } from 'uuid';
import CustomInput from '../../../myComp/CustomInput';
import CustomDropDown from '../../../myComp/CustomDropDown';
import { useProfileData } from '../../../NecttosComp/APICaller/queryHooks';
import { Body, Header, Main } from '../../../NecttosComp/Layout/Layout';
import Button from '../../../NecttosComp/Button/Button';
import Input2 from '../../../NecttosComp/Input/Input2';
import Instruction from '../../../Documentation/Instruction';

const createRadomId = (prefix = '') => {
	const uuid = uuidv4().toUpperCase();
	const parsedUuid = uuid.replace('-', '');

	return `${prefix ? `${prefix}-` : ''}${parsedUuid}`;
};

const { Option } = Select;

const years = [
	{ name: 'First Year', key: '1y' },
	{ name: 'Second Year', key: '2y' },
	{ name: 'Third Year', key: '3y' },
	{ name: 'Year not Specified', key: undefined },
];

function sumWithKey(data, key) {
	return data?.reduce((x, y) => x + y[key], 0);
}

export const EarnLeaveCalculator = ({ onClose, userId }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	
	const allClasses = useQuery(['userList', { type: 'teacher', collegeId }], getUserListNew);
	const [earnLeave, setEarnLeave] = useState([]);

	const classList = allClasses?.data?.list || [];
	const [isLoading, setIsLoading] = useState(false);

	const [stateConst, setStateConst] = useState({ list: { dues: [] } });

	const [state, setState] = useState({
		_id: '',
		limit: 1,
	});
	let isStaff = true;

	const { data: userDetail, status } = useProfileData(state?.payee?.uid, isStaff);

	let data = userDetail;

	console.log({ userDetail });
	const setConst = async () => {
		setStateConst({ ...userDetail });
	};
	const feeClearence = async () => {
		setEarnLeave([]);
	};
	const deleteItems = async (_id) => {
		stateConst.list.dues.forEach((x, i) => {
			if (x._id === _id) {
				stateConst.list.dues.splice(i, 1);
			}
		});
		setStateConst({ ...stateConst });
	};
	const onAddFees = async () => {
		try {
			setIsLoading(true);

			let filterData = [];

			years.forEach((item) => {
				if (state[item.name]) {
					filterData.push(item.key);
				}
			});

			console.log({ filterData });

			const instance = await getAxiosTokenInstance();
			let resp;
			resp = await instance.post('/college/action/postFeeStructure', {
				dues: stateConst?.list?.dues,
				collegeId,
				userId,
				classId: state.payee.classId,
			});
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				setState({
					...state,
					feesType: '',
					titleOfFee: '',
					description: '',
					dueId: '',
					isStudent: true,
					payee: '',
					amount: '',
					dueDate: '',
					date: '',
					recieptNo: '',
					_id: '',
				});
				onClose();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	let count = Array(parseInt(state?.limit) || 1).fill(1);
	let dataOfArrays = [];
	const processData = async () => {
		let arraData = [];
		count.forEach((item, i) => {
			let data = {};
			if (state['type' + i] === 'EARN') {
				data.earnLeave = (state['days' + i] * 30) / state['vecation' + i];
			} else {
				data.startDate = new Date(state['startDate' + i]);
				data.endDate = new Date(state['startDate' + i]);
			}
			arraData.push(data);
		});
		setEarnLeave([
			...earnLeave,
			{
				key: `1st year ${moment(userDetail.dateOfJoin, 'DD MMMM YYYY').format('DD.MM.YYYY')} to ${moment(new Date(moment(userDetail.dateOfJoin, 'DD MMMM YYYY')).setDate(new Date(moment(userDetail.dateOfJoin, 'DD MMMM YYYY')).getDate() + 365)).format('DD.MM.YYYY')}`,
				key2: `Block year is ${moment(userDetail.dateOfJoin, 'DD MMMM YYYY').format('DD.MM.YYYY')} to ${moment(new Date(moment(userDetail.dateOfJoin, 'DD MMMM YYYY')).setDate(new Date(moment(userDetail.dateOfJoin, 'DD MMMM YYYY')).getDate() + (365 + 13))).format('DD.MM.YYYY')}`,
				data: arraData,
			},
		]);
		setState({ limit: 1 });
	};
	console.log({ earnLeave });

	return (

		<Main width='100%' height='100%' title='Earn Leave Calculator'>
     

<Header width='100%'>
  <div className='w-[80%] flex gap-2 items-center'>
    <Input2
      type='drop'
      returnKey='payee'
      fieldName='Select class to pay this fees?'
      optionDisplay='name'
      optionKey='name'
      options={classList}
      state={state}
      setState={setState}
      className='w-[380px]'
      didntShowKey={true}
    />
    <Button
      className='bg-blue-600 text-white px-3 py-1 rounded'
      onClick={() => setConst()}
    >
      SET
    </Button>
    <Button
      className='bg-yellow-500 text-white px-3 py-1 rounded'
      onClick={() => setState({
        ...state,
        feesType: '',
        feesTypeval: '',
        dueId: '',
        feesYear: '',
        feesYearval: '',
        dueIdval: '',
        description: '',
        amount: '',
        dueDate: '',
        date: '',
        recieptNo: '',
      })}
    >
      Clear
    </Button>
    <Button
      className='bg-green-600 text-white px-3 py-1 rounded'
      onClick={feeClearence}
    >
      Add
    </Button>
  </div>
  <div className='w-[20%] flex justify-end'>
    <Instruction keyId={'earnLeaveCalculator'}></Instruction>
    <Button type='close' onClick={onClose}>Close</Button>
  </div>
</Header>




	<Body>
        <div className='text-2xl font-bold text-center my-2 dark:text-white'>{selectedCollege?.collegeName}</div>
        <div className='text-xl font-semibold text-center dark:text-white'>Block Year statement of Earned Leave Surrender (Terminal)</div>
        <div className='text-lg text-center dark:text-white'>{userDetail?.name} (Principal)</div>
       
<div className="text-sm text-center my-1  dark:text-white">
  Entered service: {userDetail?.dateOfJoin ? moment(userDetail.dateOfJoin).format('DD.MM.YYYY') : 'Invalid date'}
</div>
        <div className='text-lg font-semibold mt-4 mb-2 dark:text-white'>Calculation of Earned Leave</div>

        <div className='flex flex-col m-3'>
          {earnLeave.map((item, i) => (
            <div key={i} className='w-full h-[200px] flex border border-black p-2 mb-3'>
              <div className='flex-1 flex flex-col items-start'>
                <h5 className='text-lg font-semibold'>{item.key}</h5>
                <h5 className='text-lg font-bold'>{item.key2}</h5>
              </div>
              <div className='flex-1 flex flex-col items-center justify-center space-y-2'>
                <h5 className='text-center text-sm w-full'>AAAA</h5>
                <h5 className='text-center text-sm w-full'>EEEE</h5>
                <h5 className='text-center text-sm w-full'>UUUU</h5>
              </div>
            </div>
          ))}

          {count.map((_, i) => (
  <div key={i} className="w-[90%] flex flex-wrap gap-3 mb-4 items-center">
    {/* Leave Type dropdown */}
    <Input2
      className="w-[200px]"
      type="drop"
      fieldName="Leave Type"
      returnKey={`type${i}`}
      options={[
        { label: "HPL", value: "HPL" },
        { label: "EL", value: "EL" },
        { label: "CTL", value: "CTL" },
        { label: "Enjoy", value: "Enjoy" },
      ]}
      optionDisplay="label"
      optionKey="value"
      state={state}
      setState={setState}
    />

    {/* Conditionally render inputs based on Leave Type */}
    {state[`type${i}`] === "EL" ? (
      <>
        <Input2
          className="w-[180px]"
          type="number"
          returnKey={`days${i}`}
          fieldName="Days"
          state={state}
          setState={setState}
        />
        <Input2
          className="w-[180px]"
          type="number"
          returnKey={`vecation${i}`}
          fieldName="Vacation"
          state={state}
          setState={setState}
        />
      </>
    ) : (
      <>
        <Input2
          className="w-[180px]"
          type="date"
          returnKey={`startDate${i}`}
          fieldName="Start Date"
          state={state}
          setState={setState}
        />
        <Input2
          className="w-[180px]"
          type="date"
          returnKey={`endDate${i}`}
          fieldName="End Date"
          state={state}
          setState={setState}
        />
      </>
    )}
  </div>
))}


          <div className='flex justify-start gap-8 mt-2'>
            <Button className='bg-red-500 text-white px-4 py-2 rounded' onClick={() => setState({ ...state, limit: parseInt(state.limit) - 1 })}>-</Button>
            <Button className='bg-blue-500 text-white px-4 py-2 rounded' onClick={() => setState({ ...state, limit: parseInt(state.limit) + 1 })}>+</Button>
            <Button className='bg-green-700 text-white px-4 py-2 rounded' onClick={processData}>Compute</Button>
            <Button className='bg-indigo-700 text-white px-4 py-2 rounded' onClick={onAddFees}>Final Submit</Button>
          </div>
        </div>

        {isLoading && (
          <div className='flex justify-center items-center mt-4'>
            <LoadingAnimation />
          </div>
        )}
</Body>

		</Main>
	);
};
